module.exports = {
    advSort: 'Advanced Sort',
    viewCols: 'View Cols',
    search: 'Search',
    export: 'Export',
    refresh: 'Refresh',
    reset: 'Reset',
    sorterTips: 'Tips: Drag columns from left list to right.',
    ascDesc: 'Asc / Desc',
    cancel: 'Cancel',
    sort: 'Sort',
    chooseCols: 'Choose Columns',
    confirm: 'Confirm',
    exportTips: 'Please select export scope:',
    exportCurr:  'Export Current Page',
    exportAll: 'Export All',
    selectRowTips: 'Please select a row!'
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/locale.en.js
 ** module id = 12
 ** module chunks = 0
 **/